import { render, staticRenderFns } from "./Importing.vue?vue&type=template&id=09779710&scoped=true"
import script from "./Importing.vue?vue&type=script&lang=js"
export * from "./Importing.vue?vue&type=script&lang=js"
import style0 from "./Importing.vue?vue&type=style&index=0&id=09779710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09779710",
  null
  
)

export default component.exports